import * as M from "../../../data/maybe";
import * as F from "../../../data/function";
import * as Review from "../review";
import * as Getter from "../getter";
import * as Setter from "../setter";
import * as Fold from "../fold";
import * as Lens from "../lens";
import * as RA from "fp-ts/ReadonlyArray";
import { pipe } from "fp-ts/function";
export const prism = (t, r) => (Object.assign(Object.assign({}, t), r));
export const prismp = (review, f) => (Object.assign(Object.assign(Object.assign({}, Setter.setter((g) => (s) => M.fromMaybe(M.map(F.compose(g, review), f(s)), s), (a) => (_) => review(a))), Fold.fold((fold, empty, s) => M.reduce((a, b) => fold(b, a), empty, f(s)))), Review.review(review)));
export const re = (p) => Getter.getter(p.review);
export const has = (p, s) => pipe(Fold.toArray(p, s), RA.isNonEmpty);
export const outside = (p) => Lens.lens(Getter.getter((s) => (a) => s(p.review(a))), Setter.setter((g) => (sb) => (s) => p.foldr(g((a) => sb(p.review(a))), sb(s), s), (g) => (sb) => (s) => p.foldr((a) => g(a), sb(s), s)));

